





















import { CartScopeEq } from '@/models/cart/group/scope'
import ShippingFee from '@/models/shipping-fee'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import AppId from '@/util/appid'
import { formatPrice } from '@/util/format'

import RecommendItems from './RecommendItems.vue'

@Component({
  components: {
    RecommendItems,
  },
})
export default class PriceRangeItems extends Vue {
  @Prop({ required: true })
  scope: CartScopeEq

  @Prop({ required: true })
  fixedShippingFee: ShippingFee

  @Prop({ required: true })
  itemListUrl: string

  get itemListUrlWithQuery(): string {
    return `${this.itemListUrl}?price=${this.restPrice}-&sort=price`
  }

  get restPrice(): number {
    return this.fixedShippingFee.remainingPriceUntilFreeShipping() || 0
  }

  get restPriceLabel(): string {
    return formatPrice(this.restPrice)
  }

  get priceRangeQuery(): object {
    return {
      effective_sell_price_range: `${this.restPrice}-`,
      orderby: 'index_sell_price~asc',
      // ~aux 無しでは belonging_to に埋め込まれる ROOT の aux が返らない（Engine の with 修飾子）
      with: 'belonging_to~aux,part,stock~detail,like,indexsummary',
    }
  }

  get hasRestPrice(): boolean {
    return this.restPrice > 0
  }

  /**
   * MCのみレジで送料など合計金額を確認する旨のメッセージを表示する
   * @see https://github.com/my-color/front/issues/7094
   */
  get showTotalPriceNotice(): boolean {
    return AppId.isHostId(AppId.getByHostName('mycolor'))
  }
}
